import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Snackbar,
  IconButton,
  Divider,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { AddCircleOutline, DeleteOutline } from '@material-ui/icons';
import { StatusCampanha } from '../../../../../../helpers/enums';
import request from '../../../../../../services/network/request';
import { useAuth } from '../../../../../../auth/authProvider';
import palette from '../../../../../../theme/palette';
import { formatPrice } from '../../../../../../helpers/utils';

const InserirCampanhaModal = ({
  open,
  onClose,
  refetch,
  setFormData,
  formData,
  classes,
  setAdicaoRegrasCampanhasModal,
}) => {
  const resetFormData = () => {
    setFormData({
      nome: '',
      redirecionamento: '',
      imgDesktop: null,
      imgMobile: null,
      dataInicio: '',
      dataFim: '',
      status: StatusCampanha.Inativa,
    });
  };

  const { token } = useAuth();
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });

  const handleChange = event => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (event, field) => {
    const file = event.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        [field]: file,
      }));
    }
  };

  const [onSubmit, { isLoading }] = useMutation(
    dadosForm =>
      request.post(`/backstage/comunidade/campanhas`, dadosForm, {
        contentType: 'multipart/form-data',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    {
      onSuccess: () => {
        setSnackbar({ open: true, message: 'Campanha inserida com sucesso!' });
        setTimeout(() => {
          onClose();
          refetch();
          resetFormData();
        }, 2000);
      },
      onError: error => {
        setSnackbar({ open: true, message: error || 'Erro ao inserir campanha' });
      },
    },
  );

  const canProceed = () => {
    const { nome, dataInicio, status } = formData;
    return nome && dataInicio && status;
  };

  const handleSubmit = () => {
    if (!canProceed()) {
      setSnackbar({ open: true, message: 'Preencha todos os campos obrigatórios' });
      return;
    }

    if (formData.dataFim && formData.dataInicio && formData.dataFim < formData.dataInicio) {
      setSnackbar({ open: true, message: 'A data de fim não pode ser menor que a data de início.' });
      return;
    }

    const formCampanha = new FormData();

    const appendToFormData = (key, value) => {
      if (value === null || value === undefined) {
        return;
      }

      if (key === 'activationRules') {
        formCampanha.append(key, JSON.stringify(value));
        return;
      }

      if (key === 'imgDesktop' || key === 'imgMobile') {
        if (value instanceof File) {
          formCampanha.append(key, value);
        }
        return;
      }

      formCampanha.append(key, value);
    };

    Object.entries(formData).forEach(([key, value]) => appendToFormData(key, value));

    onSubmit(formCampanha);
  };

  function truncateFileName(name, maxLength = 13) {
    if (!name) {
      return '';
    }
    return name.length > maxLength ? `${name.slice(0, maxLength)}...` : name;
  }

  let desktopName = 'Banner desktop';
  let mobileName = 'Banner mobile';

  if (formData?.imgDesktop?.name) {
    desktopName = truncateFileName(formData.imgDesktop.name);
  } else if (formData?.imgDesktop) {
    desktopName = truncateFileName(formData?.imgDesktop);
  }

  if (formData?.imgMobile?.name) {
    mobileName = truncateFileName(formData.imgMobile.name);
  } else if (formData?.imgMobile) {
    mobileName = truncateFileName(formData?.imgMobile);
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          resetFormData();
          onClose();
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            width: '50vw',
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <Typography variant="h6" gutterBottom>
            Inserir Campanha
          </Typography>

          <TextField
            label="Nome"
            fullWidth
            required
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />
          <TextField
            label="Redirecionamento (Opcional)"
            fullWidth
            name="redirecionamento"
            value={formData.redirecionamento}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            label="Data de Início"
            type="date"
            fullWidth
            required
            name="dataInicio"
            value={formData.dataInicio}
            onChange={handleChange}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            disabled={formData.activationRules && formData.activationRules.length > 0}
          />

          <TextField
            label="Data de Fim (Opcional)"
            type="date"
            fullWidth
            name="dataFim"
            value={formData.dataFim}
            onChange={handleChange}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            error={!!formData.dataFim && !!formData.dataInicio && formData.dataFim < formData.dataInicio}
            helperText={
              !!formData.dataFim && !!formData.dataInicio && formData.dataFim < formData.dataInicio
                ? 'A data de fim não pode ser menor que a data de início.'
                : ''
            }
            disabled={formData.activationRules && formData.activationRules.length > 0}
          />

          <FormControl fullWidth margin="normal" variant="outlined" sx={{ borderRadius: 1 }}>
            <InputLabel>Status</InputLabel>
            <Select label="Status" name="status" value={formData.status} onChange={handleChange} fullWidth>
              <MenuItem value={StatusCampanha.Ativa}>{StatusCampanha.getStatus(StatusCampanha.Ativa)}</MenuItem>
              <MenuItem value={StatusCampanha.Inativa}>{StatusCampanha.getStatus(StatusCampanha.Inativa)}</MenuItem>
            </Select>
          </FormControl>

          <Typography variant="body1" style={{ marginBottom: '4px' }}>
            Selecione as imagens para os banners da campanha:{' '}
          </Typography>
          <Box className={classes.boxStyle}>
            <Button variant="outlined" color="primary" component="label" fullWidth style={{ height: '5vh' }}>
              <input
                hidden
                type="file"
                onChange={e => handleImageChange(e, 'imgDesktop')}
                accept={['image/jpeg', 'image/jpg', 'image/png'].join(', ')}
                style={{ marginBottom: 16 }}
              />
              {desktopName}
            </Button>
            <br />

            <Button variant="outlined" color="primary" component="label" fullWidth style={{ height: '5vh' }}>
              <input
                hidden
                type="file"
                onChange={e => handleImageChange(e, 'imgMobile')}
                accept={['image/jpeg', 'image/jpg', 'image/png'].join(', ')}
                style={{ marginBottom: 16 }}
              />
              {mobileName}
            </Button>
          </Box>
          <br />
          {!formData.activationRules || formData.activationRules.length === 0 ? (
            <Box className={classes.regrasCampanha}>
              <Typography variant="body1" style={{ color: palette.primary.main }}>
                Regras da campanha
              </Typography>
              <IconButton onClick={() => setAdicaoRegrasCampanhasModal(true)}>
                <AddCircleOutline style={{ color: palette.primary.main }} />
              </IconButton>
            </Box>
          ) : null}
          {formData.activationRules && formData.activationRules.length > 0 && (
            <Box style={{ marginTop: 16, background: '#f0f0f0', borderRadius: 4, padding: 12 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="h6">Regras adicionadas</Typography>
                <Button
                  color="primary"
                  size="small"
                  onClick={() =>
                    setFormData(prev => {
                      const { activationRules, ...rest } = prev;
                      return rest;
                    })
                  }
                  style={{ minWidth: 0, padding: 4 }}
                >
                  <DeleteOutline />
                </Button>
              </Box>
              {formData.activationRules.map(activationRule => (
                <Box
                  key={`rule-${activationRule.distributors.join('-')}`}
                  mb={activationRule !== formData.activationRules[formData.activationRules.length - 1] ? 2 : 0}
                >
                  <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                    <b>Distribuidoras:</b> {activationRule.distributors.join(', ')}
                  </Typography>
                  {activationRule.rules.map(rule => (
                    <Box
                      key={`rule-detail-${rule.mwMinValue}-${rule.mwMaxValue}-${rule.discountAmount}`}
                      style={{
                        background: '#fff',
                        borderRadius: 4,
                        padding: 8,
                        marginBottom: rule !== activationRule.rules[activationRule.rules.length - 1] ? 8 : 0,
                      }}
                    >
                      <Box display="flex" gap={4}>
                        <Box flex={1}>
                          <Typography variant="subtitle2">
                            <b>Faixa de consumo:</b>
                            <span className={classes.spanValues}>
                              {rule.mwMinValue} MWh {rule.mwMaxValue ? `até ${rule.mwMaxValue} MWh` : 'ou mais'}
                            </span>
                          </Typography>
                        </Box>
                        <Box flex={1}>
                          <Typography variant="subtitle2">
                            <b>Valor do desconto:</b>
                            <span className={classes.spanValues}>{formatPrice(rule.discountAmount)}</span>
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          )}

          <Divider className={classes.divider} />
          <Box className={classes.boxButtonsStyle}>
            <Button
              color="primary"
              onClick={() => {
                resetFormData();
                onClose();
              }}
              className={classes.buttonStyle}
            >
              Cancelar
            </Button>
            <Button
              className={classes.buttonStyle}
              onClick={handleSubmit}
              color="primary"
              variant="contained"
              disabled={isLoading || !canProceed()}
            >
              {isLoading ? <CircularProgress size="14px" /> : 'Enviar'}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        message={snackbar.message}
        onClose={() => setSnackbar({ open: false, message: '' })}
      />
    </>
  );
};

export default InserirCampanhaModal;
